import SendIcon from '@mui/icons-material/Send';
import { Box, Button, Container, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { useState } from 'react';
import { CONTACT_EMAIL } from '../../common/constants';
import { landingTheme } from './theme';

const inputStyles = {
  width: '100%',
  padding: '12px 16px',
  fontSize: '1rem',
  border: `1px solid ${landingTheme.colors.lightGray}`,
  borderRadius: '4px',
  fontFamily: 'inherit',
  outline: 'none !important',
  boxShadow: 'none !important',
  transition: 'border-color 0.2s ease',
  '&:hover': {
    borderColor: landingTheme.colors.primary,
  },
  '&:focus': {
    borderColor: landingTheme.colors.primary,
    borderWidth: '2px',
    padding: '11px 15px',
    outline: 'none !important',
    boxShadow: 'none !important',
  },
};

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const subject = encodeURIComponent('Grant Guardian Inquiry');
    const body = encodeURIComponent(
      `Name: ${formData.name}\n\nEmail: ${formData.email}\n\nMessage:\n${formData.message}`,
    );
    window.location.href = `mailto:${CONTACT_EMAIL}?subject=${subject}&body=${body}`;
  };

  return (
    <Box
      id="contact"
      sx={{
        py: 10,
        backgroundColor: 'white',
        textAlign: 'center',
      }}
    >
      <Container maxWidth="md">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <Typography
            variant="h3"
            sx={{
              fontSize: { xs: '1.75rem', md: '2.25rem' },
              fontWeight: 700,
              mb: 2,
            }}
          >
            Have a question not covered here?
          </Typography>
          <Typography
            variant="h6"
            color="text.secondary"
            sx={{ mb: 4, fontWeight: 400 }}
          >
            Send us a message and our team will be in touch soon.
          </Typography>

          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{ maxWidth: 600, mx: 'auto' }}
          >
            <Box sx={{ mb: 2 }}>
              <Box
                component="input"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
                sx={inputStyles}
              />
            </Box>
            <Box sx={{ mb: 2 }}>
              <Box
                component="input"
                name="email"
                type="email"
                placeholder="Email*"
                value={formData.email}
                onChange={handleChange}
                required
                sx={inputStyles}
              />
            </Box>
            <Box sx={{ mb: 3 }}>
              <Box
                component="textarea"
                name="message"
                placeholder="What's on your mind?*"
                rows={4}
                value={formData.message}
                onChange={handleChange}
                required
                sx={{
                  ...inputStyles,
                  resize: 'vertical',
                  fontFamily: 'inherit',
                }}
              />
            </Box>
            <Button
              type="submit"
              variant="contained"
              size="large"
              endIcon={<SendIcon />}
              sx={{
                px: 5,
                py: 1.5,
                borderRadius: '50px',
                fontSize: '1rem',
                fontWeight: 600,
                textTransform: 'none',
              }}
            >
              Send Message
            </Button>
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
}
